const d3 = require("d3");


class ToolTipVisual {
    constructor(visualiser) {
        this.visualiser = visualiser;
        this.createToolTipVisual();

        this.project = null;
    }

    createToolTipVisual() {
        // Define the div for the tooltip
        this.tooltip =  d3
        .select(this.visualiser.parentDiv).append("div")
        .style("position", "absolute")
        .style("class", "tooltip")
        .style("background-color", "white")
        .style("opacity", 0)
        .style("border", "solid")
        .style("border-width", "1px")
        .style("border-radius", "5px")
        .style("padding", "10px")
        .style("pointer-events", "none")
    } 

    //Set the current project
    setCurrentProject(project) {
        this.project = project;
        this.updateToolTipVisual();
    }

    //Remove the current Project
    removeCurrentProject() {
        this.project = null;
    }

    //Update the tooltip HTML
    updateToolTipVisual(){
        if (this.project == null){
            return;
        }
        const colorMapper = this.visualiser.params.colorMapper;

        var constraintThroughputHTML = "";
        if(this.visualiser.simulator.params.throughputVisible){
            constraintThroughputHTML = `<span>Throughput per CCR hour: ${this.project.constrainedThroughput.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}</span>  <br>`
        }

        this.tooltip
        .html(`<span style="font-weight:bold;">Project Name: ${this.project.name}</span> <br>
            <span>Revenue: ${this.project.revenue.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}</span> <br>
            <span>Est. Profit: ${this.project.getEstimatedProfit().toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}</span> <br>
              ${constraintThroughputHTML}

            <br>
            <span style="font-weight:bold;">Total workHours: ${this.project.getTotalHours()}</span>  <br>
            <span style="color:${colorMapper.B};font-weight:bold;">  - Blue: ${this.project.getTotalHours("B")}</span>  <br>
            <span style="color:${colorMapper.O};font-weight:bold;">  - Orange: ${this.project.getTotalHours("O")}</span>  <br>
            <span style="color:${colorMapper.I};font-weight:bold;">  - Indigo: ${this.project.getTotalHours("I")}</span>  <br>
            <span style="color:${colorMapper.M};font-weight:bold;">  - Maroon: ${this.project.getTotalHours("M")}</span>  <br>
            <span style="color:${colorMapper.A};font-weight:bold;">  - Aqua: ${this.project.getTotalHours("A")}</span>  <br>
            <span style="color:${colorMapper.P};font-weight:bold;">  - Pink: ${this.project.getTotalHours("P")}</span>  <br>
            `);
    }
    // A function that shows the tooltip when hovering
    showToolTipVisual(d, project){
        this.tooltip.interrupt();
        
        this.tooltip
        .transition()
        .duration(200)
        .style("opacity", 1)
        .delay(750)
        .on("end", this.setCurrentProject(project))
    }
    
    // A function that moves the tooltip to the correct position
    moveToolTipVisual(d){
        this.tooltip.style("top", (d.pageY - 55)+"px").style("left",(d.pageX - 195)+"px");
    }
    
    
    // A function that hides the tooltip when not hovering
    hideToolTipVisual(){
        this.tooltip.interrupt();
        this.tooltip
        .transition()
        .duration(300)
        .style("opacity", 0)
        .on("end", this.removeCurrentProject())
    }
}

module.exports = { ToolTipVisual };
